




















import {Component, Prop} from "vue-property-decorator";
import XDropdown from "@/components/SimpleDropdown.vue";

@Component({
  components: { XDropdown },
})
class ActionDropdownAct extends XDropdown {
  @Prop({ default: true }) readonly isEndStatus!: boolean;

  get itemProps() {
    let result = [
      {
        icon: "mdi-send",
        title: "Отправить email",
        evtName: "send",
      },
      {
        icon: "mdi-download",
        title: "Скачать",
        evtName: "download",
      },
    ];

    if (!this.isEndStatus) {
      result = [
        ...result,
        {
          icon: "mdi-file-document-check-outline",
          title: "Принять",
          evtName: "accept",
        },
        /*{
          icon: "mdi-file-document-minus-outline",
          title: "Отклонить",
          evtName: "decline",
        },*/
      ];
    }

    return result;
  }
}

export default ActionDropdownAct;
